
export default function AboutValues() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Fiabilité',
      description: 'Des équipements de qualité professionnelle et un service technique irréprochable pour garantir votre sécurité.',
      color: 'bg-blue-600'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Proximité',
      description: 'Un accompagnement personnalisé et une présence locale pour répondre rapidement à tous vos besoins.',
      color: 'bg-green-600'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation',
      description: 'Une veille technologique constante pour vous proposer les solutions les plus avancées du marché.',
      color: 'bg-purple-600'
    },
    {
      icon: 'ri-award-line',
      title: 'Excellence',
      description: 'Un engagement qualité total, de la conception à la maintenance, pour votre entière satisfaction.',
      color: 'bg-red-600'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nos <span className="text-red-600">Valeurs</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Les principes qui guident notre action au quotidien pour vous offrir le meilleur service
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value) => (
            <div key={value.title} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 text-center">
              <div className={`w-16 h-16 ${value.color} rounded-2xl flex items-center justify-center mx-auto mb-6`}>
                <i className={`${value.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
